// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1e70bbd9","1008":"1e70bbd9","2300":"1e70bbd9","3646":"1e70bbd9","4672":"1e70bbd9","6928":"1e70bbd9","7044":"1e70bbd9","9976":"1e70bbd9"}[chunkId] + ".chunk.css";
};